import React from 'react';

const Button = ({
  children,
  onClick,
  className = '',
  type = 'button',
  icon = null,
  disabled = false
}) => {
  return (
    <button
      type={type}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`px-6 py-3 rounded-full bg-gradient-to-r from-indigo-600 to-purple-500 text-white font-medium flex items-center justify-center gap-2
        hover:shadow-lg hover:brightness-110 active:brightness-90 transition-all duration-300 ease-in-out 
        ${disabled ? 'opacity-70 cursor-not-allowed' : ''} ${className}`}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

export default Button;